import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { RotateCcw, Shirt, Battery } from 'lucide-react';
export function ProblemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-20 px-4 md:px-8 bg-rose/30" data-id="element-119">
      <div className="max-w-5xl mx-auto" data-id="element-120">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="text-center mb-16" data-id="element-121">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl font-serif font-bold text-brown-deep mb-6 leading-tight" data-id="element-122">
            ¿Te despertás plana y terminás el día pareciendo que tenés 4 meses
            de embarazo?
          </motion.h2>
          <motion.div variants={itemVariants} className="max-w-3xl mx-auto text-lg text-brown-medium space-y-4" data-id="element-123">
            <p data-id="element-124">
              No sos vos, es tu sistema linfático pidiendo auxilio. La mayoría
              de las mujeres en Argentina compran fajas baratas en el súper o en
              la web esperando un milagro.
            </p>
            <p className="font-medium text-brown-deep" data-id="element-125">
              Pero la realidad es cruel: una faja sola solo aprieta. No drena.
              No desinflama.
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={containerVariants} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-126">
          {/* Card 1 */}
          <motion.div variants={itemVariants} className="bg-white p-8 rounded-2xl shadow-sm border border-rose/50 hover:shadow-md transition-shadow" data-id="element-127">
            <div className="w-12 h-12 bg-rose/50 rounded-full flex items-center justify-center mb-6 text-coral-dark" data-id="element-128">
              <RotateCcw className="w-6 h-6" data-id="element-129" />
            </div>
            <h3 className="text-xl font-serif font-bold text-brown-deep mb-3" data-id="element-130">
              Efecto Rebote
            </h3>
            <p className="text-brown-medium" data-id="element-131">
              Probaste de todo y siempre volvés al mismo punto. La inflamación
              vuelve apenas dejás la dieta.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div variants={itemVariants} className="bg-white p-8 rounded-2xl shadow-sm border border-rose/50 hover:shadow-md transition-shadow" data-id="element-132">
            <div className="w-12 h-12 bg-rose/50 rounded-full flex items-center justify-center mb-6 text-coral-dark" data-id="element-133">
              <Shirt className="w-6 h-6" data-id="element-134" />
            </div>
            <h3 className="text-xl font-serif font-bold text-brown-deep mb-3" data-id="element-135">
              Ropa que no cierra
            </h3>
            <p className="text-brown-medium" data-id="element-136">
              Tu jean favorito quedó en el fondo del placard. Te vestís para
              esconder, no para lucir.
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div variants={itemVariants} className="bg-white p-8 rounded-2xl shadow-sm border border-rose/50 hover:shadow-md transition-shadow" data-id="element-137">
            <div className="w-12 h-12 bg-rose/50 rounded-full flex items-center justify-center mb-6 text-coral-dark" data-id="element-138">
              <Battery className="w-6 h-6" data-id="element-139" />
            </div>
            <h3 className="text-xl font-serif font-bold text-brown-deep mb-3" data-id="element-140">
              Cansancio crónico
            </h3>
            <p className="text-brown-medium" data-id="element-141">
              La pesadez abdominal te roba energía todo el día. Sentís el cuerpo
              pesado y lento.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}